import {Ten99} from 'Agent/1099s/models/1099';
import {AsyncPage, Empty} from 'Core/models/Async';
import {DateRange, EmptyDateRange} from 'Core/models/DateRange';
import {FilterOptionUnion, FilterOptionValue} from 'Core/models/FilterOption';
import {Page} from 'Core/models/Page';
import {fromNullable, none, Option} from 'fp-ts/lib/Option';
import {Sort} from 'Shared/components/PagedView/Table/Sort';
import {createAction} from 'Shared/utilities/actionCreator';
import {ValidAgentNumber} from 'Users/models/AgentNumber';

export enum Ten99ActionType_V2 {
  GET_TEN99s_V2 = 'ten99/GET_TEN99s_V2',
  CHANGE_TEN99s = 'ten99/CHANGE_TEN99s',
  CHANGE_TEN99_FILTERS = 'ten99/CHANGE_TEN99_FILTERS',
  CHANGE_SORT = 'ten99/CHANGE_SORT',
  CLEAR_SORT = 'ten99/CLEAR_SORT',
}

export type FilterEnum = {
  name: string;
  value: string;
};

export type Ten99Filters_V2 = {
  accountNumber: string;
  accountName: string;
  history: FilterOptionUnion;
  taxFormType: FilterOptionUnion;
  statementDate: DateRange;
  sourceId: FilterOptionUnion;
};

export const EmptyTen99Filter: Ten99Filters_V2 = {
  accountName: '',
  accountNumber: '',
  history: FilterOptionValue.EmptyOption(),
  sourceId: FilterOptionValue.EmptyOption(),
  statementDate: EmptyDateRange,
  taxFormType: FilterOptionValue.EmptyOption(),
};


export const changeTen99Filters = (filters: Ten99Filters_V2) =>
  createAction(Ten99ActionType_V2.CHANGE_TEN99_FILTERS, {filters});

export const clear1099s_V2 = () => createAction(Ten99ActionType_V2.CHANGE_TEN99s, DEFAULT_STATE.ten99s);

export const getTen99s_V2 = (
  agentNumbers: ValidAgentNumber[],
  encryptedIdentifier: string,
  isNewYork: boolean,
  taxYear: string,
  filter?: Ten99Filters_V2,
  sort?: Sort,
  page?: Page<Ten99>
) =>
  createAction(Ten99ActionType_V2.GET_TEN99s_V2, {
    agentNumbers,
    isNewYork,
    encryptedIdentifier,
    taxYear,
    filter,
    sort,
    page,
  });

export const changeTen99s_V2 = (ten99s: AsyncPage<Page<Ten99>>) => createAction(Ten99ActionType_V2.CHANGE_TEN99s, ten99s);

export const changeSort = (sort?: Sort) => createAction(Ten99ActionType_V2.CHANGE_SORT, {sort});
export const clearSort = () => createAction(Ten99ActionType_V2.CLEAR_SORT);

type Ten99State = {
  ten99s: AsyncPage<Page<Ten99>>;
  ten99sFilter: Ten99Filters_V2;
  sort: Option<Sort>;
};

export const DEFAULT_STATE: Ten99State = {
  ten99s: new Empty(),
  ten99sFilter: EmptyTen99Filter,
  sort: none,
};

type Ten99Action =
  | ReturnType<typeof changeTen99Filters>
  | ReturnType<typeof getTen99s_V2>
  | ReturnType<typeof changeTen99s_V2>
  | ReturnType<typeof clearSort>
  | ReturnType<typeof changeSort>;

export default (state: Ten99State , action: Ten99Action): Ten99State => {
  const currentState = state || DEFAULT_STATE
  switch (action.type) {
    case Ten99ActionType_V2.CHANGE_TEN99_FILTERS:
      return {
        ...currentState,
        ten99sFilter: action.payload.filters,
      };
    case Ten99ActionType_V2.CHANGE_TEN99s:
      return {
        ...currentState,
        ten99s: action.payload,
      };
    case Ten99ActionType_V2.CLEAR_SORT:
      return {
        ...currentState,
        sort: DEFAULT_STATE.sort,
      };
    case Ten99ActionType_V2.CHANGE_SORT:
      return {
        ...currentState,
        sort: fromNullable(action.payload.sort),
      };
    default:
      return currentState;
  }
};

export const Ten99StatusFilter: FilterEnum[] = [
  {
    name: 'Original',
    value: 'Original',
  },
  {
    name: 'Correction',
    value: 'Correction',
  },
  {
    name: 'Corrected',
    value: 'Corrected',
  },
  {
    name: 'Exempt',
    value: 'Exempt',
  },
  {
    name: 'Zero Dropped',
    value: 'Zero Dropped',
  },
  {
    name: 'Superseded',
    value: 'Superseded',
  },
  {
    name: 'Deleted',
    value: 'Deleted',
  },
];
